import { InputTag } from 'mixs/base/input_mixin';
export class CheckboxSelect extends InputTag {
  // public init() {
  //   super.init();
  //   // this.watch();
  // }
  // public onChange(e){
    // let checked = e.target.checked ? '1' : '0';
    // let namespace = e.target.getAttribute('data-id');
    // let items = {};
    // items[namespace] = { value: checked }
    // this.dispatch({items: items, updated_at: new Date().getTime()});
  // }

}

riot.mixin('inputs.checkbox-select', CheckboxSelect as riot.TagMixin)
